export enum CAMPAIGN_PLAY_TYPE {
  TRADITIONAL_ABM = "traditional_abm",
  CONTEXTUAL_ABM = "contextual_abm",
  CONTEXTUAL_MEDIA_BUYING = "contextual_media_buying",
  CONTEXTUAL_PERSONA = "contextual_persona",
  GEO_TARGETING = "geo_targeting",
  CRM_RETARGETING = "crm_retargeting",
  SITE_RETARGETING = "site_retargeting",
  PERSONA_RETARGETING = "persona_retargeting",
  CUSTOM = "custom",
  MANAGED = "managed",
}

export const CAMPAIGN_PLAY_TYPE_LABELS: Record<CAMPAIGN_PLAY_TYPE, string> = {
  [CAMPAIGN_PLAY_TYPE.TRADITIONAL_ABM]: "Traditional ABM",
  [CAMPAIGN_PLAY_TYPE.CONTEXTUAL_ABM]: "Contextual ABM",
  [CAMPAIGN_PLAY_TYPE.CONTEXTUAL_MEDIA_BUYING]: "Contextual Media Buying",
  [CAMPAIGN_PLAY_TYPE.CONTEXTUAL_PERSONA]: "Contextual / Persona Targeting",
  [CAMPAIGN_PLAY_TYPE.GEO_TARGETING]: "Geo-Targeting",
  [CAMPAIGN_PLAY_TYPE.CRM_RETARGETING]: "CRM Retargeting",
  [CAMPAIGN_PLAY_TYPE.SITE_RETARGETING]: "Visitors Retargeting",
  [CAMPAIGN_PLAY_TYPE.PERSONA_RETARGETING]: "Persona Retargeting",
  [CAMPAIGN_PLAY_TYPE.CUSTOM]: "Custom Campaigns",
  [CAMPAIGN_PLAY_TYPE.MANAGED]: "Managed Services",
};

export const getCampaignPlayTypeLabel = (campaignType?: string | null): string => {
  if (!campaignType) return "—";

  return CAMPAIGN_PLAY_TYPE_LABELS[campaignType as CAMPAIGN_PLAY_TYPE] ?? campaignType;
};
